﻿module Client.Keyboard

open Fable.Core
open Fable.Core.JsInterop

open Fable.Import
open Fable.React
open Fable.React.Props
open Browser.Types

let [<Literal>] ENTER_KEY = 13.
let [<Literal>] ESCAPE_KEY = 27.

let a = 
    div [
        OnKeyDown 
            (fun ev -> 
                () |> ignore
            ) 
    ] [
        
    ]

let private keyPress conditional key msg dispatch =
    function 
    | (ev: KeyboardEvent) when ev.keyCode = key && conditional ->
        ev.preventDefault() 
        dispatch msg
    | _ -> ()
    |> OnKeyDown


let onEnter msg dispatch = keyPress true ENTER_KEY msg dispatch
let onEnterConditional cond msg dispatch = keyPress cond ENTER_KEY msg dispatch
let onEscape msg dispatch = keyPress true ESCAPE_KEY msg dispatch
